import { type MobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'

const styles = stylex.create({
  container: {
    backgroundColor: '#F7F7F7',
    boxSizing: 'border-box',
    minHeight: '100vh',
    paddingBottom: {
      [MOBILE]: '0px',
      default: '32px',
    },
    paddingTop: {
      [MOBILE]: '0px',
      default: '32px',
    },
  },
  card: {
    margin: 'auto',
    padding: '20px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.05)',
    boxSizing: 'border-box',
    position: 'relative',
    maxWidth: {
      [MOBILE]: '100%',
      default: '400px',
    },
    minHeight: {
      [MOBILE]: '100vh',
    },
  },
})

interface CardLoginProps {
  children: ReactNode
}

export function CardLogin(props: CardLoginProps) {
  const { children } = props

  return (
    <div>
      <div {...stylex.props(styles.container)}>
        <div {...stylex.props(styles.card)}>
          {children}
        </div>
      </div>
    </div>
  )
}
